import { render } from "./RouteHeader.vue?vue&type=template&id=ba9c9bd4"
import script from "./RouteHeader.vue?vue&type=script&lang=js"
export * from "./RouteHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__